<template>
  <div class="content">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="100px">
      <el-row>
        <el-col :span="15">
          <div class="grid-content bg-purple">
            <el-form-item label="套餐分类" prop="type">
              <el-select v-model="propsParams.type" placeholder="请选择套餐分类" @change="handleSortType">
                <el-option
                  v-for="item in sortType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资费类型" prop="productType">
              <el-select v-model="propsParams.productType" placeholder="请选择资费类型">
                <el-option
                    v-for="item in optType"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资费名" prop="productName">
              <el-input v-model="propsParams.productName" placeholder="资费"></el-input>
            </el-form-item>
            <el-form-item label="运营商" prop="operator">
              <el-input v-model="operatorPrice" placeholder="价格" style="width:130px"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <el-button type="primary" size="mini" @click="handleUpdatePrice()" style="margin-left: 10px">设置价格</el-button>
              <el-button type="primary" size="mini" @click="selectOperators()" style="margin-left: 10px">选择运营商</el-button>
            </el-form-item>
            <el-form-item>
              <div class="form-item-operator">
                <el-table :data="propsParams.operatorsPrice">
                  <el-table-column prop="operatorName" label="运营商名称" align="center" width="180"></el-table-column>
                  <el-table-column prop="price" label="价格" align="center" width="200">
                    <template #default={row}>
                      <el-input style="width: 140px;"  v-model="row.price"
                        oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                        <template slot="append">￥</template>
                        </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="80">
                    <template #default={row}>
                      <el-button type="text"  size="mini" @click="deleteOperatorPrice(row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <el-form-item label="实际价格" prop="price" v-if="poolType && !smsType">
              <el-input placeholder="实际价格" v-model="propsParams.price" >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="优惠价格" prop="discountsPrice" v-if="!poolType && !smsType">
              <el-input placeholder="价格" v-model="propsParams.discountsPrice">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="总流量" prop="flowCount" v-if="!smsType">
              <el-input placeholder="-1为不限，流量MB" v-model="propsParams.flowCount">
                <template slot="append">MB</template>
              </el-input>
            </el-form-item>
            <el-form-item label="展示总流量" prop="showFlowCount" v-if="!smsType">
              <el-input placeholder="-1为不限，流量MB" v-model="propsParams.showFlowCount">
                <template slot="append">MB</template>
              </el-input>
            </el-form-item>
            <el-form-item label="总数量" prop="total" v-if="smsType">
              <el-input placeholder="短信条数" v-model="propsParams.total">
                <template slot="append">条</template>
              </el-input>
            </el-form-item>
            <el-form-item label="有效期" prop="validityTime">
              <el-input placeholder="有效期，30天为一月，流量池加油包填 0" v-model="propsParams.validityTime">
                <template slot="append">天</template>
              </el-input>
            </el-form-item>
            <el-form-item label="市场价格" prop="showPrice">
              <el-input placeholder="价格" v-model="propsParams.showPrice" >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="描述信息" prop="remark" >
              <el-input
                style="width:355px"
                type="textarea"
                :rows="3"
                placeholder="请输入描述信息"
                v-model="propsParams.remark"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="9">
          <div class="grid-content bg-purple-light">
            <el-form-item label="备注信息" prop="description" v-if="!poolType && !smsType" >
              <el-input
                style="width:355px;"
                type="textarea"
                :rows="3"
                placeholder="请输入订单确认的备注信息"
                v-model="propsParams.description"
              ></el-input>
            </el-form-item>
            
            <el-form-item label="资费" prop="flowInfo" v-if="!poolType && !smsType">
              <el-checkbox-group v-model="propsParams.flowInfo">
                <el-checkbox v-for="item in flowInfos" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="是否启用" prop="status">
              <el-switch v-model="propsParams.status" active-color="#13ce66"></el-switch>
            </el-form-item>
            <el-form-item label="自动续费" prop="renewalFlag" v-if="!poolType && !smsType">
              <el-switch v-model="propsParams.renewalFlag" active-color="#409EFF"></el-switch>
            </el-form-item>
            <el-form-item label="续费价格" prop="renewalPrice" v-if="!poolType && !smsType">
              <el-input placeholder="价格" v-model="propsParams.renewalPrice" >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="续费描述" prop="renewalDesc"  v-if="!poolType && !smsType">
              <el-input
                style="width:355px"
                type="textarea"
                :rows="3"
                placeholder="请输入续费描述"
                v-model="propsParams.renewalDesc"
              ></el-input>
            </el-form-item>
            
          </div>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="设置运营商价格" :visible.sync="nextOperatorOpen" width="1000px"  :modal-append-to-body="true">
      <div class="dialog-operator">
        <el-table :data="operatorData"   @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="60px"></el-table-column>
          <el-table-column prop="operatorName" label="运营商名称" align="center"></el-table-column>
          <el-table-column prop="price" label="价格" align="center">
            <template #default={row}>
              <el-input style="width: 140px;"  v-model="row.price"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                <template slot="append">￥</template>
                </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
			<div class="dialog-footer" slot="footer">
				<el-button @click="confirmAddOperator" type="primary" plain>确认添加</el-button>
			</div>
    </el-dialog>
  </div>
</template>
<script>
import {getProduct, productType, updateProduct , addProduct} from "@/api/api.js"; //获取详情 //更新套餐
import { operatorList } from "@/api/international.js";
export default {
  name: "packageEdit",
  data() {
    let validateOperator = (rule, value, callback) => {
      let scs = this.propsParams.operatorsPrice
      if(scs.length == 0){
        callback(new Error('请选择运营商'));
      }else{
        callback();
      }
    }
    return {
      operatorPrice:"",
      flowInfos: [
        {value: "1", label: "推荐"},
        {value: "2", label: "基础资费"},
        {value: "3", label: "仅续费充值"},
        {value: "4", label: "限速套餐"},
        {value: "5", label: "加速包"},
        {value: "6", label: "月末折扣"},
        {value: "7", label: "不限速"},
        {value: "8", label: "热卖"},
        {value: "9", label: "4G监控流量"},
      ],
      sortType: [
        { value: "1", label: "流量套餐" },
        { value: "2", label: "短信套餐" }
      ],
      flowInfo: [],
      propsParams: {
        status:true,
        renewalFlag:true,
        flowInfo:[],
        operatorsPrice:[]
      },
      optType: [],
      baseProductType:[
        { value: "累计套餐", key: 1 },
        { value: "月套餐", key: 2 },
        { value: "加油包", key: 3 }
      ],
      optNetwork: [
        { value: 2, label: "2G" },
        { value: 3, label: "3G" },
        { value: 4, label: "4G" },
        { value: 5, label: "5G" }
      ],
      limitLevel:[
        { value: 0, label: "无限制" },
        { value: 1, label: "128K" },
        { value: 2, label: "1M" },
        { value: 3, label: "2M" }
      ],
      ruleValidate: {
        productName: [
          { required: true, message: "请输入资费名", trigger: "blur" },
           { min: 3,max: 20,message: "请输入3至20字母数字或汉字",trigger: "blur"},
        ],
        productType: [
          { required: true, message: "请选择资费类型", trigger: "blur" }
        ],
        operator:[{ validator: validateOperator, required: true, trigger: "blur" }],
        flowRatio: [
          { required: true, message: "请输入流量比例", trigger: "blur" }
        ],
        flowCount: [
          { required: true, message: "请输入总流量", trigger: "blur" }
        ],
        validityTime: [
          { required: true, message: "请输入有效期", trigger: "blur" }
        ],
        floorPrice: [
          { required: true, message: "请输入价格", trigger: "blur" }
        ],
        showPrice: [
          { required: true, message: "请输入市场价格", trigger: "blur" }
        ],
        remark:[
          { required: true, message: "请输入描述信息", trigger: "blur"}
        ],
        description:[
          { required: true, message: "请输入订单确认的备注信息", trigger: "blur"}
        ]
      },
      nextOperatorOpen:false,
      operatorData:[],
      multipleSelectionOperator:[]
    };
  },
  computed: {
    smsType() {
      return this.propsParams.type == '2';
    },
    poolType(){
      return this.propsParams.productType == '10';
    }
  },
  methods: {
    handleSortType(type){
      if(type == "2"){
        this.propsParams.productType = undefined;
        this.optType = this.baseProductType;
      }else{
        this.productTypeList();
      }
      if(this.propsParams.type != type){
          this.propsParams.operatorsPrice = []
      }
    },
    // 初始化获取数据
    initData() {
      let params = {
        id:this.$route.params && this.$route.params.id
      };
      getProduct(params).then(res=>{
        this.propsParams = res.data.data;
        this.propsParams.status = this.propsParams.status == "1" ? true : false;
        this.propsParams.renewalFlag = this.propsParams.renewalFlag == "1" ? true : false;
      })
    },
    //套餐类型列表
    productTypeList(){
      productType().then(res =>{
        this.optType = res.data.data;
      })   
    },
    // 创建套餐
    handleSubmit() {
      let params = {
        ...this.propsParams,
      };
      this.$refs.propsParams.validate(valid => {
        params.status = params.status ? 1 : 0;
        params.renewalFlag = params.renewalFlag ? 1 : 0;
        if (valid) {
          updateProduct(params).then(res => {
            this.$message.success("更新套餐成功");
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$router.push({ path: `/package/packagelist` });
          });
        }
      });
    },
    search(){
      this.selectOperatorList();
    },
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    handleUpdatePrice(){
      let price = this.operatorPrice
      this.propsParams.operatorsPrice.forEach(item=>{
        item.price = price
      })
    },
    selectOperators(){
      this.nextOperatorOpen = true
      this.selectOperatorList()
    },
    selectOperatorList(){
      operatorList({type:'1'}).then(res=>{
        this.operatorData = res.data.data
      })
    },
    handleSelectionChange(select){
      this.multipleSelectionOperator = select
    },
    deleteOperatorPrice(row){
      let services = this.propsParams.operatorsPrice;
      for (let i = services.length - 1; i >= 0; i--) {
        if(services[i].id === row.id){
          services.splice(i, 1);
        }
      }
    },
    confirmAddOperator(){
      this.nextOperatorOpen = false
      let scs = this.propsParams.operatorsPrice.map(m=>m.id)
      let operators = this.multipleSelectionOperator.filter(item=>scs.indexOf(item.id) == -1)
      this.propsParams.operatorsPrice.push(...operators)
    }
  },
  mounted() {

  },
  created() {
    this.productTypeList()
    this.initData()
  }
};
</script>
<style scoped lang="less">
.el-select {
  width: 350px;
  margin-left: 5px;
}
.el-input {
  width: 350px;
  margin-left: 5px;
}
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
.cell button {
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.el-message-box__btns .el-button--small {
  width: 75px;
}
.dialog-operator{
    overflow: auto;
    max-height: 434px;
    border-top: 1px solid #eff1f4;
    border-bottom: 1px solid #eff1f4;
    padding: 0px 10px 11px 27px;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #8798AF;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
}
.form-item-operator{
  overflow: auto;
  max-height: 434px;
}
</style>
